import type { LanguageMode } from "../doc/languageMode.js";

/**
 * Maps buffer language to highlight.js grammar id (registered in hljsRegister).
 * `null` → no lexer; escaped plaintext only.
 */
export const LANGUAGE_MODE_TO_HLJS: Record<LanguageMode, string | null> = {
  text: null,
  c: "c",
  cpp: "cpp",
  cs: "csharp",
  java: "java",
  html: "xml",
  xml: "xml",
  js: "javascript",
  ts: "typescript",
  php: "php",
  python: "python",
  json: "json",
  yaml: "yaml",
  css: "css",
  sql: "sql",
  bash: "bash",
  powershell: "powershell",
  ruby: "ruby",
  go: "go",
  rust: "rust",
  r: "r",
  lua: "lua",
  perl: "perl",
  ini: "ini",
  makefile: "makefile",
  props: "properties",
  md: "markdown",
  tex: "latex",
  max: null,
  oeis: null,
  /** Table view is primary; source uses plaintext highlight. */
  csv: null,
  excel: null,
  pdf: null,
  diff: "diff",
  linuxobj: null,
};

export function languageModeToHljsLang(mode: LanguageMode): string | null {
  return LANGUAGE_MODE_TO_HLJS[mode];
}
